import type { IconSvgObject } from './types';

const FrenchFries01Icon: IconSvgObject = [
  ["path", { d: "M7.5 18C8.88071 18 10 16.8807 10 15.5C10 14.1193 8.88071 13 7.5 13C7.32877 13 7.16155 13.0172 7 13.05", stroke: "currentColor", strokeWidth: "1.6", key: "0" }],
  ["path", { d: "M7.5 8.5L8 4L10.6 5M10 9.5L11 2L14 3L12.5 10.5M13 11L15.5 6H18.5L15 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 12.5L5.5 8L8.5 22L17.5 12.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FrenchFries01Icon;
